var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubspotHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.416,
    height: 23.467,
    viewBox: "0 0 22.416 23.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hubspot",
    transform: "translate(-293.367 -734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hubspot-1",
    d: "M26.873,11.836V9.041A2.152,2.152,0,0,0,28.114,7.1V7.038a2.152,2.152,0,0,0-2.152-2.152H25.9a2.152,2.152,0,0,0-2.152,2.152V7.1a2.152,2.152,0,0,0,1.241,1.94v2.795a6.094,6.094,0,0,0-2.9,1.276l-7.664-5.97a2.45,2.45,0,1,0-1.147,1.491l7.547,5.873a6.113,6.113,0,0,0,.093,6.885l-2.3,2.3a2.03,2.03,0,1,0,1.326,1.326l2.271-2.272a6.123,6.123,0,1,0,4.654-10.906m-.941,9.191a3.142,3.142,0,1,1,3.032-3.143,3.142,3.142,0,0,1-3.032,3.143",
    transform: "translate(283.705 729.891)",
    fill: "#ff7a59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotHistory);
export default __webpack_public_path__ + "static/media/HubspotHistory.04a9b2f6a7bb45827c845c52f83257ec.svg";
export { ForwardRef as ReactComponent };